import { render, staticRenderFns } from "./TextAreaType.vue?vue&type=template&id=55a3088a&"
import script from "./TextAreaType.vue?vue&type=script&lang=js&"
export * from "./TextAreaType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports